import classes from './style.module.css';

export const Loading = () => (
  <span className={classes.loader} />
);
